import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";

class ClientManagementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }
  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;
    return (
      <div className="pb-3" style={{ marginTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginTop: "2px" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-md-11 col-sm-11 col-11 "}>
                    <div className="row px-3 g-0">
                      <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-4"}>
                        <h6 className="resource-list-title m-auto" >{item.name} </h6>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong><span className="italicFont ">{item.mail} </span></span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Phone : </strong><span className="italicFont ">{item.phone} </span></span>
                      </div>
                      {/* <div className={showSidePane ? "col-sm-12" : "col-sm-3"}>
                        <span><strong>Address : </strong><span className="italicFont ">{item.address} </span></span>
                      </div> */}
                    </div>
                  </div>
                  <div className={"col-sm-1 col-md-1 col-1 d-flex justify-content-end"}>
                    <div className={showSidePane ? "vertical-center" : "vertical-center"}>
                      <i className="fa fa-eye fa-2x click" onClick={() => eyeclick(item)} aria-hidden="true" style={{ color: ' #1a3464', marginLeft: '-15px' }}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientManagementCard)
);
